export const countDecimals = (value) => {
  if (Math.floor(value) !== value) {
    const parts = value.toString().split('.');
    if (parts.length > 1) {
      return parts[1].length || 0;
    }
    return 0;
  }
  return 0;
};
